<template>
  <div id="app" class="f">
  <myloading v-if="!$dbData.dataLoaded"/>
  <template v-else-if="$authToken.deviceName">
    <device-page/>
  </template>
  <template v-else>
  <transition name="slideLeft" :duration="1400">
    <dashboard-menu  v-if="$store.state.usr._id"  />
  </transition>
  <my-menu  v-if="$store.state.usr._id"  />

  <router-view class="fw f" v-slot="{ Component }">
    <div class="page fstart scroller"  :class="{logged:$store.state.usr._id}" :style="{
        //backgroundImage:`url(https://${imageUrl}/public/img/bg-2.jpg)`,
        
    }">
    <transition name="slide-fade" mode="out-in" :duration="300">
      <component :is="Component" />
    </transition>
      </div>
  </router-view>
  <transition name="bounce" :duration="400">
    <q-btn v-if="staticLink.text" @click.prevent="back" id="staticLink" class="f">
      <q-icon :name="staticLink.icon || 'mdi-chevron-left'"  style="color:#111;font-size:18px" /> {{staticLink.text}}
    </q-btn>
  </transition>
  </template>
  </div>
</template>
<script>
import { createMetaMixin } from 'quasar'
import store from './store/index.ts'
import dashboardMenu from './components/menu-dashboard.vue'
import {mapGetters,mapState} from 'vuex';
import devicePage from './views/devicePage.vue'
import myMenu from './components/my-menu.vue'

export default {
  mixins: [createMetaMixin(store.state.meta)],
  components: {
    dashboardMenu,
    myMenu,
    devicePage
  },
  
  computed:{
    ...mapGetters(['isConnected']),
    ...mapState(['staticLink'])
  },
  mounted() {
    document.querySelector('#splashScreen').classList.add('closed');
    setTimeout(() =>{
      document.querySelector('#splashScreen').outerHTML = ''
    },300);
  },
  methods: {
    back(){
      this.staticLink.url ? this.$router.push(this.staticLink.url) :this.$router.back();
    }
  },
  watch:{
    'isConnected': async function(v){
      if (v){
        this.login()
      }
    },
    '$store.state.usr._id':async function(_id){
      if (_id){
        this.$socket.subscribe(`i/${_id}/logout`).watch(()=>{
          this.$store.commit('logout');
        })
      }
    },
  },
  metaInfo:{
    title:'PrivacyReady.'
  }
}
</script>
<style lang="scss">
@import "@/css/main.scss";
$animationDuration: 0.3s; // specify animation duration. Default value: 1s
#app {
  font-family: Inter;
  position: relative;
  background-color:#737373;
}
.lt {
  font-family: inter;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.page {
  @extend .f;
  flex-grow: 1;
  align-self: stretch;
  overflow: hidden;
  justify-content: flex-start;
  height:100vh;
  padding:10px;
  overflow-y: auto;
  width: 100vw;
  position: absolute;
  right: 0;
  top:0;
  background-size: cover;
  //mask-image:linear-gradient(0deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0,1) 90%, rgba(0, 0, 0,.3) 93%, rgba(0, 0, 0,.25) 95%, rgba(0, 0, 0,0) 99%);
  mask-image:linear-gradient(180deg, rgba(#000, 0) 0px, rgba(#000,.5) 70px, rgba(#000,1) 90px);
  &>div {
    padding:10px;
    @extend .f, .fstart;
  }

}
.page.logged {
  width: calc( 100% - 220px);
}

.whiteboard {
  min-height: calc(100vh - 116px);
  margin:70px 0;
  width: 100%;
  padding:12px;
  background-color:#ffffffe8;
  border-radius: 15px;
  align-items: flex-start;
  justify-content: flex-start;
}

  h1 {
    font-weight: bold;
    font-size: 20px;
    max-width: 350px;
    margin-right: 25px;
    border-bottom: 1px solid #000 ;
    text-align: left;
    width: 50%;
    padding-bottom: 10px;
    line-height: 24px;
  }

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(30px);
  opacity: 0;
}
input[type="text"]::placeholder {
  color:#999;
  font-weight: 400;
}
[bold] {
  font-weight: bold;
}
#staticLink {
  position: absolute;
  padding:5px 20px;
  border-radius: 15px;
  background-color: #fff;
  color:#111;
  position: absolute;
  left:270px;
  top:25px;
  text-transform: uppercase;
  text-decoration: none;

}
.ql-snow{
.ql-picker{
    &.ql-size{
        .ql-picker-label,
        .ql-picker-item{
            &::before{
                content: attr(data-value) !important;
            }
        }
    }
}
}
strong {
  font-weight: bold;
}
</style>
